import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { X } from 'lucide-react';

const VideoModal = ({ isOpen, onClose, videoSrc }) => {
    const modalRef = useRef(null);
    const contentRef = useRef(null);
    const overlayRef = useRef(null);

    useEffect(() => {
        if (isOpen) {
            // Entry animation
            gsap.fromTo(overlayRef.current,
                { opacity: 0 },
                { opacity: 1, duration: 0.4, ease: 'power2.out' }
            );
            gsap.fromTo(contentRef.current,
                { opacity: 0, scale: 0.8, y: 20 },
                { opacity: 1, scale: 1, y: 0, duration: 0.6, ease: 'back.out(1.7)' }
            );
        }
    }, [isOpen]);

    const handleClose = () => {
        // Exit animation
        gsap.to(contentRef.current, {
            opacity: 0,
            scale: 0.8,
            y: 20,
            duration: 0.4,
            ease: 'power2.in',
            onComplete: onClose
        });
        gsap.to(overlayRef.current, {
            opacity: 0,
            duration: 0.4,
            ease: 'power2.in'
        });
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 md:p-10">
            {/* Overlay */}
            <div
                ref={overlayRef}
                className="absolute inset-0 bg-black/90 backdrop-blur-sm"
                onClick={handleClose}
            />

            {/* Content Container */}
            <div
                ref={contentRef}
                className="relative w-full max-w-6xl aspect-video bg-black rounded-3xl overflow-hidden shadow-2xl border border-white/10"
            >
                <button
                    onClick={handleClose}
                    className="absolute top-4 right-4 z-50 p-2 rounded-full bg-black/50 text-white hover:bg-black/70 transition-colors"
                >
                    <X size={24} />
                </button>

                <video
                    src={videoSrc}
                    className="w-full h-full object-contain"
                    controls
                    autoPlay
                    playsInline
                />
            </div>
        </div>
    );
};

export default VideoModal;
